module.exports = __webpack_public_path__ + "static/media/icon-piece1-5.549006f7.png";